import { RequestResponse } from "../../DTO/requestResponse";
import { Request } from "../../CONSTANTS/request";
import { MICROSERVICIOS } from "../../CONSTANTS/constants";


export default class ConsultaNochero {

    // ConsultaNochero.ShowNow() <- asi se usa
    static async ShowNow(): Promise<RequestResponse> {


    

        return new Request(MICROSERVICIOS.NOCHERO).getNochero('https://supervisor.mystarken.cl/Nochero/Show');
    }


//ConsultaNochero.KillNow() <- asi se usa
    static async KillNow(id: string): Promise<RequestResponse> {

        let PID = { "pid": String(id) };

        return new Request(MICROSERVICIOS.NOCHERO).postNochero('Kill', PID);
    }


    
//ConsultaNochero.KillNow() <- asi se usa
static async MultiKillNow(id: string): Promise<RequestResponse> {

    let DBNAME = { "dbname": id };

    return new Request(MICROSERVICIOS.NOCHERO).postNochero('MultiKill', DBNAME);
}



}